import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
} from "@/components/ui/card";
import { Paragraph } from "@/components/ui/typography";

import { cn } from "@/lib/utils";

function CourseSection({
  title,
  action,
  children,
  className,
  cardHeaderClassName,
  cardContentClassName,
  ...props
}) {
  return (
    <Card
      className={cn("gap-y-5 lg:gap-y-8 shadow-none py-0", className)}
      {...props}
    >
      <CardHeader className={cn("p-0", cardHeaderClassName)}>
        <Paragraph variant="b1" weight="bold">
          {title}
        </Paragraph>
        <CardAction className="card-action">{action}</CardAction>
      </CardHeader>

      <CardContent className={cn("block !px-0", cardContentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}

export default CourseSection;
